import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';
import queryString from 'qs';

export const STATUS_MAP = {
    success: 'Berhasil',
    failed: 'Gagal',
};

const formatHistoryData = (histories = []) =>
    histories.map((history) => ({
        ...histories,
        date_uploaded: history.date_uploaded?.replace(/\s{2,}/, ' - '),
        name: history.name,
        type_date: history.type_date,
        status: STATUS_MAP[history.status] || history.status,
        upload_type: history.upload_type
            ? `${history.upload_type} - ${history.detail_upload_type ?? 'none'}`
            : undefined,
    }));

const getHistoryParams = (sortType) => {
    if (!sortType?.name) return '';

    return `?${queryString.stringify({
        sort: `${sortType.name}.${sortType.type}`,
        limit: 5,
    })}`;
};

const fetchHistory = async (params) => {
    const { data } = await authAxios.post(`/api/v1/sellout/upload-history${params}`);
    return formatHistoryData(data?.data || []);
};

export function useGetHistory({ sortType, enabled = true }) {
    const params = getHistoryParams(sortType);

    return useQuery({
        queryKey: ['audit-trail-history', params],
        queryFn: () => fetchHistory(params),
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: !!enabled,
    });
}
